// One place that turns an UPPER_SNAKE_CASE code into the words shown on screen. Codes are title-
// cased unless they are listed here: acronyms and names that title-casing would mangle
// ("Fpic Violation"). The backend mirrors this map in src/utils/casePdf.js and mapFilters.js.
export const LABEL_OVERRIDES: Record<string, string> = {
  FPIC_VIOLATION: 'Free, Prior and Informed Consent Violation',
};

export const enumLabel = (value: string | null | undefined): string => {
  const v = String(value || '');
  return LABEL_OVERRIDES[v] || v.split('_').map((w) => (w ? w.charAt(0) + w.slice(1).toLowerCase() : w)).join(' ');
};
